export const Divider = () => (
  <div className="flex h-4 flex-grow border-b-2 border-primary-25" />
);
